import { render, staticRenderFns } from "./HOME_FAV.vue?vue&type=template&id=76082220&scoped=true"
import script from "./HOME_FAV.vue?vue&type=script&lang=ts"
export * from "./HOME_FAV.vue?vue&type=script&lang=ts"
import style0 from "./HOME_FAV.vue?vue&type=style&index=0&id=76082220&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76082220",
  null
  
)

export default component.exports